define(
    'models/report.model',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox
        )
    {
        var _ = Loader._;

        var AdminReportModel = Loader.Backbone.Model.extend({

            defaults: {
                id: null,
                userId: null,
                userLogin: null,
                ip: null,
                report: null,
                topicId: null,
                topicTitle: null,
                postId: null,
                isRead: null,
                readerId: null,
                readerLogin: null,
                readTime: null,
                time: null
            }
        });

        /*return {
            initialize: function(model)
            {
                return new AdminReportModel({
                    model: model
                })
            }
        }*/

        return AdminReportModel;
    }
);

